import { all } from 'redux-saga/effects';

import organizationFlow from './organization/organizationFlow';
import applicationFlow from './application/getEnvironmentVariables';
import authenticationFlow from './authentication/authenticationFlow';
import enrollmentFlow from './enrollment/enrollmentFlow';

export default function* rootSaga() {
  yield* applicationFlow();
  yield all([organizationFlow(), enrollmentFlow(), authenticationFlow()]);
}
